export enum EmailValidationVerdict {
  Valid = 'Valid',
  Invalid = 'Invalid',
}

export interface IEmailValidationMessage {
  code: string
  message: string
}

export interface IEmailValidationModel {
  email: string
  verdict: EmailValidationVerdict
  warnings: IEmailValidationMessage[]
  errors: IEmailValidationMessage[]
}
